import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
function PageLoadingIndicator({ visible, iconSet = 'bootstrap-icons', }) {
    const [showLoadingIndicator, setShowLoadingIndicator] = useState(false);
    useEffect(() => {
        if (!visible) {
            setShowLoadingIndicator(false);
        }
        const timeoutId = setTimeout(() => setShowLoadingIndicator(visible), 250);
        return () => clearTimeout(timeoutId);
    }, [visible]);
    return (_jsxs("div", Object.assign({ className: "text-center mt-5 custom-loading-indicator", style: {
            opacity: showLoadingIndicator ? 1.0 : 0.0,
            visibility: showLoadingIndicator ? 'visible' : 'hidden',
        } }, { children: [_jsx("div", { className: "spinner-border", role: "status" }), _jsx("span", Object.assign({ className: "visually-hidden" }, { children: "Loading..." }))] })));
}
export default PageLoadingIndicator;
//# sourceMappingURL=PageLoadingIndicator.js.map